export const OnboardingEndpoints = {
  getOnboarding: (idCommunity: number) => `/v1/onboarding/community_admin/${idCommunity}`,
  putOnboarding: (idOnboarding: number, typeOnboarding: string) =>
    `/v1/onboarding/community_admin/${idOnboarding}/steps/${typeOnboarding}`,
  getOnboardingIA: () => '/rest/v1/ai/completions'
}
